const documentsToBeReviewedMap = {
    'ES': ['ESCONTRA', 'ESPLOC', 'ESCONTRALR', 'ESCONTRALE', 'ESCONTRARE'],
    'PT': ['PTCONTRA', 'PTAF', 'PTSBM'],
    'UK': [],
    'GB': []
}

const documentsToBeReviewedMapProduct = {
    'DPFR - 24 month Loan Stock DE': ['VER', 'VERFU', 'VERPG', 'VERVP'],
    'DPFR - Loan Stock DE': ['VER', 'VERFU', 'VERPG', 'VERVP'],
    'DPFR - Loan DE': ['VER', 'VERFU', 'VERPG', 'VERVP'],
    'Loan DE': ['VER', 'VERFU', 'VERPG', 'VERVP']
}
export const documentsToBeReviewed = (countryCode, financeProduct) => {
    const financeProductElement = documentsToBeReviewedMap[countryCode];
    if (financeProductElement === undefined) {
        return documentsToBeReviewedMapProduct[financeProduct] || [];
    }
    return financeProductElement;
}
